import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
// import LayoutOfPacerSearch from './containers/LayoutOfPacerSearch';
// import CaseLookup from './pages/filings/CaseLookup/CaseLookup';
// import LayoutOfFacetsBlock from './containers/LayoutOfFacetsBlock';
import Filings from './pages/filings/Filings';
import ErrorBoundary from './ErrorBoundary';
import ReportsTab from './pages/filings/SearchCourtRecords/ReportsTab/ReportsTab';


/**
 * Note for HMR, these 4 components must have an error in them somewhere
 * I can get HMR to work on a temp component, but these might be importing some weird js someplace
 */
class App extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Router>
          <div>
            <Route exact
                   path="/filings"
                   render={() =>
                    (<Redirect to="/filings/search-court-filings" />)
                   }
            />
            <Route path="/filings/:tab" component={Filings} />
          </div>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.jsx
 **/